module.exports = __webpack_public_path__ + "static/logo_large-9016ba5b7cdcca4c6d0fa9a425cd7b6b.png";